var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { H3 } from "@irati/ui/src/Headings";
import { RouterLink } from "@irati/ui/src/Link";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { FormattedMessage } from "@irati/utils/lang";
var StyledRouterLink = styled(RouterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  text-transform: none;\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  text-transform: none;\n  &:hover {\n    text-decoration: none;\n  }\n"])));
var BackToWallets = /** @class */ (function (_super) {
    __extends(BackToWallets, _super);
    function BackToWallets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackToWallets.prototype.render = function () {
        return (React.createElement(StyledRouterLink, { to: "/reporting-v2/wallets" },
            React.createElement(Icon, { icon: IconTypes.chevronLeft, size: 20 }),
            React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "admin.reportingV2.wallet.backToWallets.title", values: { title: this.props.title } }))));
    };
    return BackToWallets;
}(PureComponent));
export default BackToWallets;
var templateObject_1;
